module.exports = __webpack_public_path__ + "static/media/evolutiongo.6eb9edb2.svg";